"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlatformService = void 0;
const rxjs_1 = require("rxjs");
class PlatformService {
    constructor() {
        this.defaultValue = {
            isMobile: false
        };
        this.deviceInfo = new rxjs_1.BehaviorSubject(this.defaultValue);
        this.getDeviceInfo$ = this.deviceInfo.asObservable();
    }
    setDeviceInfo(value) {
        this.deviceInfo.next(value);
    }
}
exports.PlatformService = PlatformService;
//# sourceMappingURL=platform.service.js.map